<template>
  <div class="new_common_header">
    <div @click="$router.push('/')" class="logo pointer">
      <div class="flex-ac-jc"><img src="@/assets/img/platform-logo.png" /></div>
      <div class="flex-ac-jc"><img :src="logoImg" /></div>
    </div> 
    <div class="link">
      <a-link 
        v-if="windowWidth >= 1200"
        v-for="(item, index) in linkList" 
        :key="index" 
        :href="item.link"
        :status="item.link == '/' + $route.name || 
        item.link == $route.meta.url ||
        item.link.indexOf('/' + $route.name ) != -1 ? 'success' : 'normal'" >{{ item.title }}</a-link>
    </div>
    <div class="btn" v-if="windowWidth < 1200" >
      <a-dropdown class="navigate" trigger="hover">
        <a-button><svg-icon icon-class="menu" />导航</a-button>
        <template #content>
          <a-doption 
          v-for="(item, index) in linkList" 
          :key="index" 
          :class="{ active: 
            item.link == '/' + $route.name || 
            item.link == $route.meta.url  ||
            item.link.indexOf('/' + $route.name ) != -1
            }">
            <a :href="item.link"><svg-icon :icon-class="item.icon" />{{ item.title }}</a>
          </a-doption>
        </template>
      </a-dropdown>
      <!-- <UserInfoPanel @loginClick="visible = true" :loginData="loginData" @loginOut="loginOut"></UserInfoPanel> -->
      <!-- <a-button type="primar y" @click="loginClick">注册/登录</a-button>  -->
    </div>
    <!-- <WechatModal :visible="visible || ($store.state.open ? true : false)" @close="closeClick" ></WechatModal>
    <FirstLoginModal :visible="first" :loginData="loginData" @close="firstClick"></FirstLoginModal> -->
  </div>
</template>

<script>
import logoImgOne from '@/assets/img/platform-name-l.png'
import logoImgTwo from '@/assets/img/platform-name-s.png'
// import UserInfoPanel from './UserInfoPanel.vue'
// import WechatModal from './WechatModal.vue'
// import FirstLoginModal from './FirstLoginModal.vue'
  export default {
    // components: {
    //   UserInfoPanel,
    //   WechatModal,
    //   FirstLoginModal
    // },
    data() {
      return {
        linkList: [
          { title: '首页', link: '/home', icon: 'home' },
          { title: '政策法规', link: '/policiesAndRegulations', icon: 'file' },
          { title: '标准研制', link: '/standardDevelopment', icon: 'standard' },
          { title: 'PCR 查询', link: '/PCRsearch', icon: 'signpost' },
          { title: '标准信息库', link: '/standardInformationBase', icon: 'task' },
          { title: '双碳示范', link: '/doubleCDemonstration', icon: 'profile-line' },
          { title: '培训课程', link: '/trainingCourses', icon: 'training' },
          { title: '标委会信息', link: '/standardCommittee/TC', icon: 'seedling' },
        ],
        windowWidth: window.innerWidth,
        visible: false,
        first: false,
        loginData: null
      }
    },
    watch: {
      '$store.state.open': {
        handler(n) {
          if(n) this.visible = true;
        }
      },
      '$store.state.userInfo': {
        handler(n, o) {
          if(n) {
            this.loginData = null;
            this.loginData = n;
            if(n.url) this.loginData.avatarUrl = n.url
          }
        },
        immediate: true
      }
    },
    computed: {
      logoImg() {
        return this.windowWidth < 1451 ? logoImgTwo : logoImgOne
      }
    },
    mounted() {
      this.updateWindowWidth(); // 初始化宽度
      window.addEventListener('resize', this.handleResize);
      this.showPage()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
      updateWindowWidth() {
        this.windowWidth = window.innerWidth;
      },
      closeClick(type) {
        if(type && type.openId) {
          this.first = type.isFirstLogin == 0 ? false : true
          this.loginData = type
        }
        this.visible = false
      },
      firstClick(type) {
        if(type) this.showPage()
        this.first = false
      },
      showPage() {
        this.$API.ForntUserDetail().then(res => {
          if(res.data.code == 200) {
            this.loginData = res.data.data;
            this.$store.commit('login_type', 1)
          }
        })
      },
      loginOut() {
        this.loginData = null;
      }
    }
  }
</script>

<style lang="scss">
  .new_common_header {
    // min-width: 1200px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 72px;
    flex-wrap: nowrap;
    position: fixed;
    top: 0;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.08); 
    z-index: 10;
    padding-right: 20px;

    .logo {
      display: flex;
      margin-right: 40px;
      flex: 0;

      & > div {
        &:first-child {
          width: 70px;
          height: 72px;
          background: linear-gradient(179deg,#00bc96 0%, #1bbdcb 100%);

          & > img {
            width: 54px;
            height: 54px;
          }
        }

        &:last-child {
          width: 367px;
          height: 72px;
          background: linear-gradient(91deg,#eefffb 1%, #ffffff 94%);

          & > img {
            width: 367px;
          }
        }
      }
    }

    .link {
  
      .arco-link {
        padding: 9px 15px;
        font-size: 16px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }

      .arco-link-status-success {
        font-weight: 700;
      }

      .arco-link-status-normal {
        color:  #1d2129;
      }
    }

    .btn {
      position: absolute;
      right: 20px;
      display: flex;
      align-items: center;

      .arco-btn {
        height: 36px;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 4px;
        display: flex;
        align-items: center;

        &:first-child {
          margin-right: 8px;
        }

        .svg-icon {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
      }

      .arco-btn-secondary {
        padding: 0 20px 0 15px;
      }
    }
  }
  // @media only screen and (max-width: 1170px) {
  //   .btn {
  //     position: static!important;
  //     right: auto!important;
  //   }
  // }

  @media only screen and (max-width: 660px) {
    .new_common_header {
      justify-content: start;

      .logo {
        margin-right: 20px;
        & > div {
          &:last-child {
            display: none;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1279px) {
    .new_common_header {
      justify-content: start;

      .logo {
        margin-right: 20px;
        & > div {
          &:last-child {
            width: 330px;

            & > img {
              width: 330px;
            }
          }
        }
      }

      .link {
        .arco-link {
          padding: 9px 10px;
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  @media only screen and (min-width: 1279px) and (max-width: 1451px) {
    .new_common_header {
      justify-content: start;

      .logo {

        & > div {
          &:last-child {
            width: 330px;

            & > img {
              width: 330px;
            }
          }
        }
      }

      .link {
        .arco-link {
          padding: 9px 10px;
          font-size: 14px;
          margin-right: 10px;
        }
      }
    }
  }

  @media only screen and (min-width: 1779px) {
    .link {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  .navigate {
    width: 134px;

    .arco-dropdown-list-wrapper {
      max-height: 324px;

    }

    .svg-icon {
      width: 14px;
      height: 14px;
      margin-right: 16px;
    }

    .arco-dropdown-option {
      line-height: 40px;
      & > span > a {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #4E5969;

        &:hover {
          background: #f2f3f5;
          border-radius: 2px;
        }
      }

      
    }

    .active {
      background: #f2faf9;
      border-radius: 2px;
      font-weight: 600;

      & > span > a {
        color: #05a081;
      }
    }
  }
</style>